import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import TfaMpProvider from "@/core/data-provider/data-mp/tfa/tfa-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useGoogleCode() {
  const tError = useErrorTranslation();

  const [checkIsPending, setCheckIsPending] = useState(false);
  const [checkError, setCheckError] = useState<string>("");
  const [checkIsCompleted, setCheckIsCompleted] = useState<null | boolean>(null);
  const [authenticator, setAuthenticator] = useState<
    typeof RegionShared.Backend.Responses.GoogleEnableSendResponse | null
  >(null);

  const getAuthenticatorHandler = useCallback(async () => {
    try {
      const response = await TfaMpProvider.getAuthenticatorQr();

      if (response instanceof RpcMpProviderSuccessResponse) {
        setAuthenticator(response.data);
      } else {
        // TODO:
      }
    } catch ({ message }) {
      // TODO:
    }
  }, []);

  const checkCodeHandler = useCallback(
    async (code: string, enable = true) => {
      try {
        if (!code) return;
        if (checkIsPending) return;
        setCheckIsPending(true);
        setCheckError("");

        const response = await TfaMpProvider.checkGoogleCode(
          code,
          enable
            ? RegionShared.Backend.Events.Account.TwoFactorGoogleEnableCheck
            : RegionShared.Backend.Events.Account.TwoFactorGoogleDisableCheck,
        );

        if (response instanceof RpcMpProviderSuccessResponse) {
          setCheckIsCompleted(true);
        } else {
          setCheckError(tError(response.message));
          setCheckIsCompleted(false);
        }
      } catch ({ message }) {
        setCheckError(tError(message));
        setCheckIsCompleted(false);
      } finally {
        setCheckIsPending(false);
      }
    },
    [checkIsPending],
  );

  return {
    getAuthenticatorHandler,
    checkCodeHandler,
    checkError,
    setCheckIsPending,
    authenticator,
    checkIsCompleted,
    checkIsPending,
  };
}
